











import {Component, Prop, Vue,Watch} from "vue-property-decorator";
@Component({})
export default class EnabledSwitch extends Vue {
    private enabled : boolean = false;
    @Prop({}) value!:string;
    @Prop({}) action!:string;
    @Prop({default:"12"}) md!:string;
    @Prop({default:"enabled"}) queryString!:string;
    @Prop({default:false}) disabled!:boolean;
    @Watch('value')
    onPropertyChanged(value: string, oldValue: string) {
        this.switchChange();
    }
    async changeVal(){
        let val = "0";
        if(this.enabled == true)
            val = "1";
        if(this.action){
            try{
                let response = await this.$http.patch(this.action+"?"+this.queryString+"="+val);
                //console.log(response.data);
            }catch (e) {
                val = "0";
                this.enabled = false;
            }
        }
        this.$emit('input', val);

    }
    switchChange(){
        if(this.value == "1"){
            this.enabled = true;
        }else{
            this.enabled = false;
        }
    }
    mounted(){
        //console.log("created");
        this.switchChange()
    }

    created(){
      //console.log("created");
      this.switchChange()
    }
}
